import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.regexp.constructor";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.match";
import "core-js/modules/es.string.search";
import "core-js/modules/web.dom-collections.for-each";
import { cloneDeep } from 'lodash';
/**
 * setCookie
 *
 * @export
 * @param {string} name
 * @param {string} value
 * @param {number} [expiredays=365]
 */

export function setCookie(name, value) {
  var expiredays = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 365;
  var exdate = new Date();
  exdate.setDate(exdate.getDate() + expiredays);
  document.cookie = `${name}=${escape(value)};expires=${exdate.toUTCString()}`;
}
/**
 * getCookie
 *
 * @export
 * @param {string} name
 * @returns
 */

export function getCookie(name) {
  if (document.cookie.length > 0) {
    var cStart = document.cookie.indexOf(name + '=');

    if (cStart !== -1) {
      cStart = cStart + name.length + 1;
      var cEnd = document.cookie.indexOf(';', cStart);

      if (cEnd === -1) {
        cEnd = document.cookie.length;
      }

      return unescape(document.cookie.substring(cStart, cEnd));
    }
  }

  return '';
}
/**
 * clearCookie
 *
 * @export
 * @param {string} name
 */

export function clearCookie(name) {
  setCookie(name, '');
}
/**
 * 从url获取参数
 *
 * @export
 * @param {string} name
 * @returns {string}
 */

export function queryURL(name) {
  var reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`, 'i');
  var result = window.location.search.substr(1).match(reg);

  if (result !== null) {
    return decodeURI(result[2]);
  }

  return null;
}
/**
 * 数组查询
 *
 * @export
 * @template T
 * @param {any[]} array
 * @param {string} key
 * @param {string} [keyAlias='key']
 * @returns {T}
 */

export function queryArray(array, key) {
  var keyAlias = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'key';

  if (!(array instanceof Array)) {
    return null;
  }

  var item = array.filter(a => a[keyAlias] === key);

  if (item.length) {
    return item[0];
  }

  return null;
}
/**
 * 数组格式转树状结构
 *
 * @export
 * @template T
 * @param {any[]} array
 * @param {string} [id='id']
 * @param {string} [pid='pid']
 * @param {string} [children='children']
 * @returns {T[]}
 */

export function arrayToTree(array) {
  var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'id';
  var pid = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'pid';
  var children = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'children';
  var data = cloneDeep(array);
  var result = [];
  var hash = {};
  data.forEach((_, index) => {
    hash[data[index][id]] = data[index];
  });
  data.forEach(item => {
    var hashVP = hash[item[pid]];

    if (hashVP) {
      if (!hashVP[children]) {
        hashVP[children] = [];
      }

      hashVP[children].push(item);
    } else {
      result.push(item);
    }
  });
  return result;
}